/**
 * Constants for on-call technician manager overrides
 * These values match the backend constants in app/constants/on-call-override.ts
 */

export const OVERRIDE_STATUS = {
  ACTIVE_NOW: 'Active Now',
  SCHEDULED: 'Scheduled',
} as const

export type OverrideStatus =
  (typeof OVERRIDE_STATUS)[keyof typeof OVERRIDE_STATUS]
